const E = "_session.deadline", s = "_session.ready", _ = "_session.refreshingEnd", N = "_session.refreshingStart";
export {
  E as INTERNAL_EVT_SESSION_DEADLINE,
  s as INTERNAL_EVT_SESSION_READY,
  _ as INTERNAL_EVT_SESSION_REFRESHING_END,
  N as INTERNAL_EVT_SESSION_REFRESHING_START
};
